import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-product-structured-data',
    templateUrl: './product-structured-data.component.html',
    styleUrls: ['./product-structured-data.component.scss']
})
export class ProductStructuredDataComponent implements OnInit {
    @Input() product;
    @Input() sku;
    @Input() skuId;
    @Input() unitPrice;

    trustedUrl: SafeUrl;
    trustedImageUrl: SafeUrl;

    structuredData = {
        skuId: '',
        gtin14: '',
        productName: '',
        productImage: '',
        productDescription: '',
        productUrl: '',
        brandName: '',
        skuPrice: 0,
        priceValidUntil: '2021-07-31',
    };

    constructor(
        // tslint:disable-next-line:variable-name
        private _sanitizer: DomSanitizer,
    ) {
    }

    ngOnInit(): void {
        this.structuredData.productName = `${this.product.name} - Yorkstone`;

        if (this.product.subText) {
            this.structuredData.productName = this.structuredData.productName + ` ${this.product.subText}`;
        }
        this.structuredData.productDescription = this.product.descriptionString;
        this.trustedUrl = this.getSafeValue(`https://yorkstonesupplies.co.uk/products/${this.product.slug}`);

        const [ firstImage, secondImage ] = this.product.productImages;
        this.structuredData.productImage = secondImage?.url || firstImage?.url;

        this.structuredData.skuId = this.skuId;
        this.structuredData.skuPrice = +(+this.unitPrice + ((+this.unitPrice / 100) * 20)).toFixed(2);
        this.structuredData.skuPrice = +this.structuredData.skuPrice * +this.product.minQty;
    }


    getSafeValue(v) {
        return this._sanitizer.bypassSecurityTrustResourceUrl(v);
    }

}
